import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { InviteOrganizationUserDialog } from '@/features/organization-users/components/invite-organization-user-dialog'
import { OrganizationUsersTable } from '@/features/organization-users/components/organization-users-table'
import { useOrganizationUsers } from '@/features/organization-users/hooks/use-organization-users-api'
import { useSession } from '@/shared/hooks/useSession'

export function OrganizationUsersPage() {
  const { t } = useTranslation('organizationUsers')
  const {
    session: {
      id: selfUserId,
      organization: { id: organizationId },
    },
  } = useSession()
  const [inviteOpen, setInviteOpen] = useState(false)

  const organizationUsersQuery = useOrganizationUsers(organizationId)
  const isLoading = organizationUsersQuery.isLoading

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center p-6">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  const users = organizationUsersQuery.data ?? []

  return (
    <div className="flex flex-1 flex-col gap-6 p-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">
            {t('pages.organizationUsers.title')}
          </h1>
          <p className="text-muted-foreground">
            {t('sections.usersList.description')}
          </p>
        </div>
        {users.length > 0 && (
          <Button type="button" onClick={() => setInviteOpen(true)}>
            {t('actions.inviteUser')}
          </Button>
        )}
      </div>

      <OrganizationUsersTable
        data={users}
        organizationId={organizationId}
        selfUserId={selfUserId}
        onInvite={() => setInviteOpen(true)}
      />

      <InviteOrganizationUserDialog
        organizationId={organizationId}
        open={inviteOpen}
        onOpenChange={setInviteOpen}
      />
    </div>
  )
}
